import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./why-cinch.module.css";
import { Heading } from "@cinch-labs/design-system";
import { useViewport } from "@cinch-labs/shared-util";
import { WhyCinchCarousel } from "./why-cinch-carousel";
export const WhyBuyContentCard = ({ content  })=>{
    const { title , text  } = content;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.contentCard,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: title
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.paragraph,
                children: text
            })
        ]
    });
};
export const WhyCinch = ({ whyBuyContent  })=>{
    const { vw  } = useViewport({
        updateOnResize: true,
        updateOnOrientationChange: true
    });
    const isMobile = vw < 768;
    return isMobile ? /*#__PURE__*/ _jsx("section", {
        className: styles.carouselWrapper,
        children: /*#__PURE__*/ _jsx(WhyCinchCarousel, {
            content: whyBuyContent,
            carouselName: "why-buy-carousel"
        })
    }) : /*#__PURE__*/ _jsx("section", {
        className: styles.root,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.contentContainer,
            children: whyBuyContent.map((content)=>/*#__PURE__*/ _jsx(WhyBuyContentCard, {
                    content: content
                }, `content-${content.title}`))
        })
    });
};
